/* KOBOONI PDP interactions: policy modal, tidy dimensions and expandable notes.
   Operates only on the product page; source product descriptions are unchanged. */
(function () {
  'use strict';
  function initPolicy() {
    document.querySelectorAll('[data-kb-dialog]').forEach(function (trigger) {
      if (trigger.dataset.kbBound) return;
      trigger.dataset.kbBound = '1';
      trigger.addEventListener('click', function () {
        var target = document.getElementById(trigger.getAttribute('data-kb-dialog'));
        if (target && typeof target.showModal === 'function') target.showModal();
      });
    });
    document.querySelectorAll('.kb-policy-dialog').forEach(function (dialog) {
      if (dialog.dataset.kbBound) return;
      dialog.dataset.kbBound = '1';
      dialog.querySelectorAll('[data-kb-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }
  function nodeHeading(node) {
    return node && node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
  }
  function takeSection(heading, className) {
    if (!heading.parentNode) return null;
    var parent = heading.parentNode;
    var wrap = document.createElement('section');
    wrap.className = className;
    parent.insertBefore(wrap, heading);
    var current = heading;
    while (current && (current === heading || !nodeHeading(current))) {
      var next = current.nextSibling;
      wrap.appendChild(current);
      current = next;
    }
    return wrap;
  }
  function initDescriptions() {
    document.querySelectorAll('.kb-product-editorial__content .kb-product-copy').forEach(function (copy) {
      if (copy.dataset.kbEnhanced) return;
      copy.dataset.kbEnhanced = '1';
      Array.from(copy.children).filter(function(n){return nodeHeading(n);}).forEach(function(heading) {
        var title = heading.textContent.trim();
        if (/^(approximate\s+)?(dimensions|measurements|size\s*(?:&|and)\s*dimensions)$/i.test(title)) {
          var box = takeSection(heading, 'kb-measurement-panel');
          if (!box) return;
          var extraction = box.cloneNode(true);
          extraction.querySelectorAll('br').forEach(function(br){br.replaceWith(document.createTextNode('\n'));});
          var txt = extraction.textContent.replace(title,'').trim();
          var rows = txt.split(/\n+/).map(function(t){return t.trim();}).filter(Boolean).map(function(t){
            var m=t.match(/^([^:]{2,18}):\s*(.+)$/); return m?[m[1].trim(),m[2].trim()]:null;
          });
          heading.classList.add('kb-measurement-panel__title');
          if (rows.length>=2 && rows.every(Boolean)) {
            while (heading.nextSibling) heading.nextSibling.remove();
            var list = document.createElement('dl'); list.className='kb-measurement-rows';
            rows.forEach(function(r) {var pair=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=r[0];dd.textContent=r[1];pair.append(dt,dd);list.appendChild(pair);});
            box.appendChild(list);
          }
        }
        if (/^please\s+note$/i.test(title)) {
          var note = takeSection(heading, 'kb-notes-panel');
          if (!note) return;
          var lower = note.textContent.toLowerCase();
          var phrases=[];
          if (/not full.size|display use only|display use/.test(lower)) phrases.push('Miniature display piece, not full-size furniture.');
          if (/props.*not included|display props not included/.test(lower)) phrases.push('Scene props are not included unless listed.');
          if (/young children|choking|small parts/.test(lower)) phrases.push('Small parts: keep away from young children.');
          if (/handmade|measurements may vary|slight variations/.test(lower)) phrases.push('Finish and measurements may vary slightly.');
          if (phrases.length < 2) return;
          var details=document.createElement('details');details.className='kb-notes-full';
          var summary=document.createElement('summary');summary.textContent='Full product notes';
          details.appendChild(summary);
          while (heading.nextSibling) details.appendChild(heading.nextSibling);
          heading.textContent='Good to know';
          var line=document.createElement('p');line.className='kb-notes-short';line.textContent=phrases.join(' ');
          note.append(line,details);
        }
      });
    });
  }
  function init(){initPolicy();initDescriptions();}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();